// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"0bfe93ff","527":"76543ec5"}[chunkId] + ".chunk.js";
};